import React, { useState, useEffect } from 'react'
import {
    InputBase,
    Grid,
    Button
} from "@material-ui/core";
import useStyles from "./styles";
import { SearchOutlined as SearchIcon } from '@material-ui/icons';
import ClearIcon from '@material-ui/icons/Clear';
import SearchGrid from '../../../../components/table/SearchGrid';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import RefreshIcon from '@material-ui/icons/Refresh';
import { PostDataAPI } from '../../../../Services/APIService';
import Loader from '../../../../components/Loader/Loader';
import { ActionDialog } from "../../../../components/ActionDialog/ActionDialog";
import { withSnackbar } from "../../../../components/Message/Alert";
import { formatDateTime, getLocalDateFromUTC } from '../../../../../src/components/Common/Extensions';
import CreateLetterOfSupport from './createLetterOfSupport/CreateLetterOfSupport';
import * as signalR from "@microsoft/signalr";
import LosPreview from "./losView/LosView";



function LetterOfSupport({ trackingType, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const [selectedItem, setSelectedItem] = useState({});
    const [newLOS, setNewLOS] = useState(false);
    const [letterOfSupportList, setLetterOfSupportList] = useState([]);
    const [releaseStatus, setReleaseStatus] = useState([]);
    const OpenNewLetterOfSupport = () => {
        setSelectedItem({});
        setNewLOS(true)
    }

    const CloseNewLetterOfSupport = () => {
        setNewLOS(false)
    }


    //action dialog
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    })

    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState(prevState => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback
        }));
    }


  
    const [state, setState] = useState({});


    const [isDataGridUpdate, setIsDataGridUpdate] = useState(false);
    const [isLoading, setIsLoading] = useState(false);



    const handleDataGridUpdate = () => {
        setIsDataGridUpdate(!isDataGridUpdate);
    }


    const [filteredStatus, setFilteredStatus] = useState([]);


    const [searchFilter, setValue] = useState('');
    const handleSearch = (e) => {
        const currValue = e.target.value;
        if (currValue.trim().length > 0 || currValue == '') {
            setValue(currValue);
            handleDataGridUpdate()
        }
    }
    // Function to clear the input field
    const handleClearInput = (name) => {
        setValue('');
        handleDataGridUpdate();
    };

    const loadLetterOfSupportGrid = () => {
        setIsLoading(true);
        PostDataAPI("letterofsupport/loadGrid").then((result) => {
            if (result.success && result.data != null) {
                var record = result.data.map((item, i) => {
                    item.createDate = formatDateTime(getLocalDateFromUTC(item.createDate));
                    item.openRate = item.emailOpenCount > item.emailSentCount ? item.emailSentCount : item.emailOpenCount;
                    if (item.scheduleDateTime) {
                        item.scheduleDateTime = getLocalDateFromUTC(item.scheduleDateTime);
                    }
                    return { ...item };
                })
                setLetterOfSupportList(record);
            }
            else {
                setLetterOfSupportList([]);
            }
            handleDataGridUpdate();
            setIsLoading(false);

        })
    }
    const handleSuccessClose = (message) => {
        CloseNewLetterOfSupport();
        showMessage("Success", message, "success", 3000);
        loadLetterOfSupportGrid();
    }

    const [losView, setLosView] = useState(false);
    const openLosView = (item) => {
        setSelectedItem(item);
        setLosView(true)
    }

    const closeLosView = () => {
        setLosView(false);
    }
    const handleActionClick = (key, item) => {
        setLosView(false);
        setSelectedItem([])
        switch (key) {
            case 'lOSReceived':
                openLosView(item)
                break;
            case 'delete':
                deleteLetterOfSupport(item)
                break;
            case 'edit':
                setSelectedItem(item);
                setNewLOS(true);
                break;
        }
    }
    
    const deleteLetterOfSupport = (record) => {
        showActionDialog("Are you sure you want to delete this record?", "confirm", function () {
            setIsLoading(true);
            var method = "letterofsupport/delete";

            var params = { letterOfSupportId: record.letterOfSupportId }
            PostDataAPI(method, params, true).then((result) => {
                if (result.success) {
                    if (result.data) {
                        setIsLoading(false);
                        handleSuccessClose("Record deleted successfully.");

                    }
                    else {
                        showMessage("Error", "Error deleting record, please contact administrator", "error", 3000);
                    }
                }
                else {
                    showMessage("Error", result.message, "error", 3000);

                }
                setIsLoading(false);

            })
        });
    }
    const getLetterOfSupportStatus = () => {
        let baseUrl = sessionStorage.getItem('server_api_url');
        //alert(baseUrl);
        const connection = new signalR.HubConnectionBuilder()
            .withUrl(baseUrl.replace("/api","") + "ffHub")
            .build();

        connection.on("LetterOfSupport", (message) => {
            debugger;
            if (message == 'update') {
                setReleaseStatus([...releaseStatus, message]);
                loadLetterOfSupportGrid();
            }
        });

        connection.start().then(() => {
            const signalRConnectionId = sessionStorage.getItem('signalRConnectionId');
            console.log('Connection ID:', signalRConnectionId);
        }).catch(err => console.error(err));

        return () => {
            connection.stop();
        };
    }
    useEffect(() => {
        loadLetterOfSupportGrid();
        getLetterOfSupportStatus();
    }, [releaseStatus]);

    return (
        <>
            {isLoading ? <Loader></Loader> : ''}
            <Grid row className={classes.gridHeader}>

                <div className={classes.gridActions}>
                    <Button className={classes.changeBtn} onClick={() => loadLetterOfSupportGrid()}><RefreshIcon style={{ marginRight: '6px' }} /> <span> Refresh </span></Button>
                    <Button className={classes.changeBtn} onClick={() => OpenNewLetterOfSupport()}><AddCircleOutlineIcon style={{ marginRight: '6px' }} /> <span> Create Letter of Support </span></Button>
                </div>


                <div className={classes.gridActions} style={{ marginRight: '7px' }} >
                    <InputBase
                        value={searchFilter}
                        placeholder="Search"
                        className="grid-search-input"
                        endAdornment={searchFilter ? <ClearIcon style={{ cursor: 'pointer' }} onClick={() => { handleClearInput('search') }} /> : ''}
                        startAdornment={<SearchIcon />}
                        onChange={handleSearch}
                    />
                </div>

            </Grid>



            <Grid row className={classes.container} >
                <SearchGrid columns="LetterofSupportTab"
                    list={letterOfSupportList}
                    noRecordMsg="No record exists"
                    Icon={true}
                    isUpdate={isDataGridUpdate}
                    filter={searchFilter}
                    onActionClick={handleActionClick}
                    isTopPagination={true}
                />
            </Grid>


            {newLOS ?
                <CreateLetterOfSupport
                    dialogOpenClose={OpenNewLetterOfSupport}
                    handleClose={CloseNewLetterOfSupport}
                    handleSuccessClose={handleSuccessClose}
                    selectedItem={selectedItem}
                > </CreateLetterOfSupport > : ""
            }

            {losView ?
                <LosPreview
                    dialogOpenClose={openLosView}
                    handleClose={closeLosView}
                    selectedItem={selectedItem}
                > </LosPreview > : ""
            }
          



<ActionDialog
    type={actiondialogState.type}
    message={actiondialogState.message}
    actiondialogOpenClose={actiondialogState.showHide}
    onSubmit={actiondialogState.onClickOk}
    onCancel={() =>
        setActionDialogState(prevState => ({
            ...prevState, showHide: false
        }))
    }
    onClose={() => setActionDialogState(prevState => ({
        ...prevState, showHide: false
    }))

    }
/>

        </>
    )

}

export default withSnackbar(LetterOfSupport);